import { getInsurancePersonIsEligibleV2 } from '@axo/shared/data-access/api/insurance';
import { useAPI } from '@axo/shared/data-access/provider';
import type { insurance } from '@axo/shared/data-access/types';
import { useMutation, useQuery } from 'react-query';
import { InsurancePersonIsEligibleV2Keys } from '../cache-keys/insurancePersonIsEligibleV2Keys';
import { reportEligibilityError } from '../services/insurance/reportEligibilityError';

export const useInsurancePersonIsEligible = () => {
  const api = useAPI();

  // TODO
  return useMutation(
    (params: insurance.InsurancePersonIsEligibleV2Params) =>
      getInsurancePersonIsEligibleV2(api)(params),
    { onError: reportEligibilityError }
  );
};

export const useGetInsurancePersonIsEligible = (
  params: insurance.InsurancePersonIsEligibleV2Params
) => {
  const api = useAPI();
  const cacheKey = InsurancePersonIsEligibleV2Keys.getEligibility(params);
  return useQuery(cacheKey, () => getInsurancePersonIsEligibleV2(api)(params), {
    enabled: !!params.CustomerID && !!api.token,
  });
};
